import React from 'react';
import { X, Building, MapPin, Calendar, Users, Home, Ruler } from 'lucide-react';

const ProjectModal = ({ project, onClose }) => {
  if (!project) return null;

  return (
    <div className="project-modal-overlay" onClick={onClose}>
      <div className="project-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <div className="modal-image">
          <img src={project.image} alt={project.title} loading="lazy" decoding="async" />
          <span className={`modal-status-badge ${(project.details.status || '').toLowerCase()}`}>
            {project.details.status}
          </span>
        </div>
        
        <div className="modal-content">
          <span className="modal-category">{project.category}</span>
          <h2 className="modal-title">{project.title}</h2>
          <p className="modal-description">{project.description}</p>
          
          <div className="modal-details-grid">
            {project.details.client && (
              <div className="modal-detail-item">
                <Users size={20} />
                <div>
                  <span className="detail-label">Client</span>
                  <span className="detail-value">{project.details.client}</span>
                </div>
              </div>
            )}
            
            {project.details.blocks && (
              <div className="modal-detail-item">
                <Building size={20} />
                <div>
                  <span className="detail-label">Blocks/Buildings</span>
                  <span className="detail-value">{project.details.blocks}</span>
                </div>
              </div>
            )}
            
            {project.details.floors && (
              <div className="modal-detail-item">
                <Home size={20} />
                <div>
                  <span className="detail-label">Floors</span>
                  <span className="detail-value">{project.details.floors}</span>
                </div>
              </div>
            )}
            
            {project.details.apartments && project.details.apartments !== "N/A" && (
              <div className="modal-detail-item">
                <MapPin size={20} />
                <div>
                  <span className="detail-label">Units</span>
                  <span className="detail-value">{project.details.apartments}</span>
                </div>
              </div>
            )}
            
            {project.details.builtUpArea && (
              <div className="modal-detail-item">
                <Ruler size={20} />
                <div>
                  <span className="detail-label">Built-up Area</span>
                  <span className="detail-value">{project.details.builtUpArea}</span>
                </div>
              </div>
            )}
            
            {project.details.siteArea && project.details.siteArea !== "N/A" && (
              <div className="modal-detail-item">
                <MapPin size={20} />
                <div>
                  <span className="detail-label">Site Area</span>
                  <span className="detail-value">{project.details.siteArea}</span>
                </div>
              </div>
            )}
            
            <div className="modal-detail-item">
              <Calendar size={20} />
              <div>
                <span className="detail-label">Timeline</span>
                <span className="detail-value">
                  {project.details.startDate} - {project.details.endDate || 'Ongoing'}
                </span>
              </div>
            </div>
          </div>
          
          {project.details.scopeOfWork && (
            <div className="modal-scope">
              <h4>Scope of Work</h4>
              <p>{project.details.scopeOfWork}</p>
            </div>
          )}
          
          {project.details.currentStatus && (
            <div className="modal-current-status">
              <h4>Current Status</h4>
              <p>{project.details.currentStatus}</p>
            </div>
          )}
          
          {project.details.location && (
            <div className="modal-location">
              <h4>Location</h4>
              <p>{project.details.location}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
